import qs from 'qs'
import ls from 'store'
import traverse from 'traverse'
import dotProp from 'dot-prop'
import { navigate as gatsbyNavigate } from 'gatsby'
import * as consts from './consts'
import PromisePolyfill from 'promise-polyfill'

export const Promise = PromisePolyfill

export const noop = () => {}

export const removeTrailingSlash = str => {
  try {
    return str.replace(/\/+$/, '')
  } catch (err) {
    return str
  }
}

export const scrollToTop = () => {
  if (!getWindow()) return
  setTimeout(() => window.scrollTo(0, 0), 11)
}

export const getUrlParam = (url, index = 0) => {
  if (typeof url !== 'string') return ''
  url = url.trim()
  url = url.split('?')[0]
  if (url[0] === '/') url = url.substr(1)
  return url.split('/')[index]
}

export const wait = (ms, cb) => {
  if (getWindow()) {
    return new Promise(resolve => {
      setTimeout(() => {
        resolve()
        cb && cb()
      }, ms)
    })
  }
}

export const parseQuery = str => {
  if (typeof str !== 'string') return {}
  if (str[0] === '?') str = str.substring(1)
  try {
    return qs.parse(str)
  } catch (err) {
    return {}
  }
}

export const createQuery = obj => {
  if (typeof obj !== 'object') return ''
  const str = qs.stringify(obj, { encode: false })
  return str ? `?${str}` : ''
}

export const objectToArray = obj => {
  try {
    return Object.keys(obj)
      .filter(key => key !== 'key')
      .map(key => obj[key])
  } catch (err) {
    return []
  }
}

export const loadState = () => {
  try {
    return getLocalStore(consts.STATE_KEY) || {}
  } catch (err) {
    return {}
  }
}

export const jsonClone = value => {
  try {
    return JSON.parse(JSON.stringify(value))
  } catch (err) {
    return null
  }
}

export const deepClone = value => {
  try {
    const clone = traverse.clone(value)
    traverse.forEach(value, function() {
      if (this.node && this.node.constructor === File) dotProp.set(clone, this.path.join('.'), this.node)
    })
    return clone
  } catch (err) {
    return null
  }
}

export const toObject = value => {
  try {
    return JSON.parse(JSON.stringify(value))
  } catch (err) {
    return value
  }
}

export const saveState = (store, keys = []) => {
  const state = store.getState()
  const obj = {}
  keys.forEach(key => (obj[key] = state[key]))
  try {
    setLocalStore(consts.STATE_KEY, obj)
  } catch (err) {
    // noop
  }
}

export const range = (min, max) => {
  min = Math.ceil(min)
  max = Math.floor(max)
  return Math.floor(Math.random() * (max - min + 1)) + min
}

export const toJson = obj => {
  try {
    return JSON.stringify(obj)
  } catch (err) {
    return null
  }
}

export const setLocalStore = (key, value) => {
  if (getWindow()) {
    return ls.set(`${consts.LOCAL_STORE_PREFIX}-${key}`, value)
  }
}

export const getLocalStore = key => {
  if (getWindow()) {
    return ls.get(`${consts.LOCAL_STORE_PREFIX}-${key}`)
  }
}

export const getWindow = () => {
  return typeof window !== 'undefined' ? window : 0
}

export const navigate = (...args) => {
  // Gatsby throws a build error if using navigate inside a components constructor
  // This helper makes sure window is available before navigating
  // error #95312 ReferenceError: window is not defined
  // "window" is not available during server side rendering.
  // node_modules/gatsby-link/index.js:213:1
  getWindow() && gatsbyNavigate(...args)
}

export const addKeys = value => {
  try {
    const clone = deepClone(value)
    traverse(clone).forEach(function() {
      try {
        if (typeof this.node === 'object' && !Array.isArray(this.node)) this.node.key = this.path.join('.')
      } catch (err) {
        // noop
      }
    })
    return clone
  } catch (err) {
    return value
  }
}
